import { Image } from "antd";
import React, { forwardRef } from "react";
import config from "../consts/config";

export const LocalImage = forwardRef((props, ref) => {
  return (
    <Image
      {...props}
      src={props.src ? `${config.CDN_URL}${props.src}` : config.IMAGE_EMPTY}
      ref={ref}
      
    />
  );
});
